@if (shouldShow$ | async) { @for (items of items$ | async; track items) {
<epc-dynamic-collections-outlet [items]="items">
</epc-dynamic-collections-outlet>
} }
